import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const waiversListData: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fwaivers%2Fwaiver%20example-min.png?alt=media&token=43a01784-d0d3-4e6f-909c-51772000e160",
  title: "Waivers System",
  subtitle: "One Click Waivers",
  page: WildNavigationType.WAIVERSPAGE,
}